import { IdTitle, IIdTitle } from "ui/Scripts/source/models/common/idTitle";
import { Translations } from "ui/Scripts/source/models/translations";

/* eslint-disable no-unused-vars */
export const enum RecordPageListActivityFilterId {
    None = "0",
    Active = "1",
    Archived = "2",
    UserConnected = "3",
    UserNotConnected = "4",
    FamiliarizationNotApproved = "5",
}
/* eslint-enable no-unused-vars */

export const getRecordActivityFilters = (report: boolean): IIdTitle[] => {
    const result: IIdTitle[] = [];
    result.push(IdTitle.createIdTitle(RecordPageListActivityFilterId.None, "'" + Translations.All + "'"));
    result.push(IdTitle.createIdTitle(RecordPageListActivityFilterId.Active, Translations.InUse));
    result.push(IdTitle.createIdTitle(RecordPageListActivityFilterId.Archived, Translations.Archived));
    result.push(IdTitle.createIdTitle(RecordPageListActivityFilterId.UserConnected, Translations.UserAccountConnected));
    result.push(IdTitle.createIdTitle(RecordPageListActivityFilterId.UserNotConnected, Translations.UserAccountNotConnected));
    if (!report) {
        result.push(IdTitle.createIdTitle(RecordPageListActivityFilterId.FamiliarizationNotApproved, Translations.UserUnapprovedFamiliarization));
    }
    return result;
};
